import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const PowerSavingInfoContainer = styled.div<React.CSSProperties>`
  width: ${1410 * Screen.widthRatio}px;
`;

export default PowerSavingInfoContainer;
